import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styles from './Pagination.module.css';

const Pagination = ({ page, totalPages = 5, onChange }) => {
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

    return (
        <div className="d-flex align-items-center justify-content-end gap-2 mt-4">
            <button
                type="button"
                className={styles.pageButton}
                disabled={page === 1}
                onClick={() => onChange(page - 1)}
                aria-label="Previous page"
            >
                <FiChevronLeft />
            </button>
            {pages.map((number) => (
                <button
                    key={number}
                    type="button"
                    className={`${styles.pageButton} ${page === number ? styles.pageButtonActive : ''}`}
                    onClick={() => onChange(number)}
                >
                    {number}
                </button>
            ))}
            <button
                type="button"
                className={styles.pageButton}
                disabled={page === totalPages}
                onClick={() => onChange(page + 1)}
                aria-label="Next page"
            >
                <FiChevronRight />
            </button>
        </div>
    );
};

export default Pagination;
